import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Rodrigo Fuentes",
    city: "Rancagua",
    role: "Agricultor",
    initials: "RF",
    color: "bg-brand-yellow text-brand-ink",
    text: "Aseguramos toda la maquinaria del fundo (2 tractores y una cosechadora) a una tarifa mucho mejor que la que teníamos. Atención rápida y clara.",
  },
  {
    name: "Camila Rojas",
    city: "Antofagasta",
    role: "Constructora",
    initials: "CR",
    color: "bg-brand-ink text-white",
    text: "Cotizamos el seguro de nuestras excavadoras y en menos de un día nos llamaron con una propuesta clara. Nos explicaron todo sin letra chica.",
  },
  {
    name: "Jorge Méndez",
    city: "Concepción",
    role: "Clínica dental",
    initials: "JM",
    color: "bg-slate-800 text-white",
    text: "Necesitábamos asegurar todos los equipos médicos y electrónicos de la clínica. La cobertura contra daños y robo fue justo lo que buscamos.",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonios" className="py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-yellow">
            Lo que dicen nuestros clientes
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink">
            Clientes que ya protegen su maquinaria y equipos.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`}
              className="relative rounded-2xl border border-gray-200 bg-white p-7 transition-all hover:-translate-y-1 hover:shadow-lg hover:shadow-brand-ink/5"
            >
              <Quote className="absolute right-6 top-6 h-8 w-8 text-brand-yellow/20" />
              <blockquote className="text-sm leading-relaxed text-gray-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className={`flex h-11 w-11 items-center justify-center rounded-full font-semibold text-sm ${t.color}`}>
                  {t.initials}
                </div>
                <div>
                  <p className="font-display font-semibold text-brand-ink">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.role} · {t.city}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
